// EU-wide language list (selectable). Not all languages are fully translated yet.
// Fallback behavior is handled in i18n/index.js (fallbackLocale: 'en').

export const LANGUAGE_OPTIONS = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
  { code: 'bg', label: 'Български' },
  { code: 'hr', label: 'Hrvatski' },
  { code: 'cs', label: 'Čeština' },
  { code: 'da', label: 'Dansk' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'et', label: 'Eesti' },
  { code: 'fi', label: 'Suomi' },
  { code: 'fr', label: 'Français' },
  { code: 'el', label: 'Ελληνικά' },
  { code: 'hu', label: 'Magyar' },
  { code: 'ga', label: 'Gaeilge' },
  { code: 'it', label: 'Italiano' },
  { code: 'lv', label: 'Latviešu' },
  { code: 'lt', label: 'Lietuvių' },
  { code: 'mt', label: 'Malti' },
  { code: 'pl', label: 'Polski' },
  { code: 'pt', label: 'Português' },
  { code: 'ro', label: 'Română' },
  { code: 'sk', label: 'Slovenčina' },
  { code: 'sl', label: 'Slovenščina' },
  { code: 'es', label: 'Español' },
  { code: 'sv', label: 'Svenska' },
  { code: 'is', label: 'Íslenska' },
  { code: 'no', label: 'Norsk' },
  { code: 'sr', label: 'Српски' },
  { code: 'uk', label: 'Українська' }
];

export const SUPPORTED_LOCALES = LANGUAGE_OPTIONS.map((l) => l.code);

export function isSupportedLocale(code) {
  return SUPPORTED_LOCALES.includes(code);
}
